import './DraftProduct.css';

/**
 * La nota de producto del portal donde iría el producto (2026-10-16). Sin
 * etiqueta ni explicación (Daniel, 2026-10-16): solo en cursiva, que la
 * distingue del producto definitivo sin decir nada.
 * Sin nota no pinta nada, para poder ponerlo directamente tras un `??`.
 */
export function DraftProduct({ text }: { text?: string }) {
  if (!text) return null;
  return <span className="draft-product">{text}</span>;
}
